import React, { useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import AuthGate from './components/AuthGate';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import Dashboard from './pages/Dashboard';
import RecommendationPage from './pages/RecommendationPage';
import FavoritesPage from './pages/FavoritesPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import Navigation from './components/Navigation';
import FavoriteDataCleanup from './components/FavoriteDataCleanup';
import { useAuth } from './contexts/AuthContext';

function AppContent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showLanding, setShowLanding] = useState(true);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Email verification sayfası için özel kontrol
  if (location.pathname === '/verify-email') {
    return <EmailVerificationPage />;
  }

  if (!isAuthenticated) {
    // Eğer landing page gösterilmesi gerekiyorsa
    if (showLanding) {
      return <LandingPage onGetStarted={() => setShowLanding(false)} />;
    }
    // Landing'den sonra auth page göster
    return <AuthPage />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard setActiveTab={setActiveTab} />; // setActiveTab prop'u eklendi
      case 'recommend': // Navigation'da 'recommend' kullanılıyor
        return <RecommendationPage />;
      case 'favorites': // Yeni eklenen favoriler sayfası
        return <FavoritesPage />;
      case 'history':
        return <HistoryPage />;
      case 'settings': // Yeni eklenen ayarlar sayfası
        return <SettingsPage />;
      default:
        return <Dashboard setActiveTab={setActiveTab} />; // Default case'de de eklendi
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />

      <main className="pt-16 sm:pt-20 md:pt-24 lg:pt-28 pb-4 px-0">
        {renderContent()}
      </main>

      {/* Favori verileri otomatik temizlik komponenti */}
      <FavoriteDataCleanup />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          {/* Görev 3: AuthGate - Auth yüklenirken beklet */}
          <AuthGate>
          <Router>
            <AppContent />
          </Router>
          </AuthGate>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
